(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_popup_ingredient"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
        $(".cstm-ingredient_main_btn").on('click', function(){   
               $('.ingredient_popup').show();
               $('.popup_ingredient_overlay').css("z-index", "9999");
               $('.popup_ingredient_overlay').css("opacity", "1");
               $("body").css("overflow", "hidden");
                $(document).on('click', '.popup_ingredient_overlay svg', function(){
                 $('.popup_ingredient_overlay').css("opacity", "0");
                  $('.popup_ingredient_overlay').css("z-index", "-1");
                   $("body").css("overflow", "visible");
                   $('.ingredient_popup').hide();
          });              
       });
     
      
     });

  } catch(e) { console.error(e); }
})();
})();
